module.exports = __webpack_public_path__ + "media/_archive/Z-134e76bb.png";